module.exports = __webpack_public_path__ + "static/img/xls.5a0a3c0a.png";